import React from "react";
import Anav from "../components/Anav"
import Homefooter from "../components/Homefooter"
import Utable from "../components/Utable";

function Users() {
    return (
        <>
            <Anav />
            <Utable />
            <Homefooter />
        </>
    );
}

export default Users;